import type { Pricing, PricingProduct } from './PricingBlock.types';

export const prices: Pricing = {
  GBP: {
    starter: {
      month: 'Free',
      month_link: 'https://platform.globaldatabase.com/public/signup/free_tier_uk',
      year: 'Free',
      year_link: 'https://platform.globaldatabase.com/public/signup/free_tier_uk',
    },
    professional: {
      month: 49,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=55&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month&keyword=uk_accelerate',
      year: 39,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=55&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year&keyword=uk_accelerate',
    },
    payg_pipeline_starter: {
      month: 99,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=183&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 84,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=183&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg_pipeline_professional: {
      month: 199,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=188&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 169,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=188&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg_pipeline_business: {
      month: 299,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=186&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 254,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=186&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg2_starter: {
      month: 99,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=183&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 84,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=183&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg2_professional: {
      month: 199,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=188&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 169,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=188&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg2_business: {
      month: 299,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=186&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 254,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=186&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
  },
  EUR: {
    starter: {
      month: 'Free',
      month_link: 'https://platform.globaldatabase.com/public/signup/free_tier_de',
      year: 'Free',
      year_link: 'https://platform.globaldatabase.com/public/signup/free_tier_de',
    },
    professional: {
      month: 49,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=164&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month&keyword=de_accelerate',
      year: 39,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=164&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year&keyword=de_accelerate',
    },
    payg_pipeline_starter: {
      month: 99,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=176&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 84,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=176&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg_pipeline_professional: {
      month: 199,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=187&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 169,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=187&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg_pipeline_business: {
      month: 299,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=185&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 254,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=185&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg2_starter: {
      month: 99,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=176&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 84,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=176&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg2_professional: {
      month: 199,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=187&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 169,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=187&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
    payg2_business: {
      month: 299,
      month_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=185&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=month',
      year: 254,
      year_link:
        'https://platform.globaldatabase.com/public/payment/summary?data%5B0%5D%5Btype%5D=product&data%5B0%5D%5Bdata%5D%5Bcountry_id%5D=&data%5B0%5D%5Bdata%5D%5Bproduct_id%5D=185&data%5B0%5D%5Bdata%5D%5Bfrequency%5D=year',
    },
  },
};

export const data: PricingProduct[] = [
  {
    type: 'starter',
    name: 'Starter',
    description: 'Perfect for small businesses and startups',
    button_label: 'Start free trial',
    keyFeature: {
      value: '1,000',
      title: 'Company Credits / Month',
    },
    pricing_groups: [
      'Verify 10 basic company profiles',
      '50 contact lookups (email & phone)',
      'Native CRM Integration (Salesforce, HubSpot & MS Dynamics)',
      'Research on-the-go with Browser Extension',
    ],
  },
  {
    type: 'professional',
    name: 'Professional',
    description: 'For growing teams that need more data and features',
    best_value: true,
    button_label: 'Get started',
    price_explanation: 'per user, per month',
    keyFeature: {
      value: '3,500',
      title: 'Company Credits / Month',
    },
    pricing_groups: [
      'Verify 1,000 full company profiles',
      'Access to 300 million companies',
      'Shareholders & Group Structure',
      'Full company financials',
      'API access',
    ],
  },
  {
    type: 'custom',
    name: 'Enterprise',
    description: 'Custom solutions for unique requirements',
    book_demo: true,
    button_label: 'Contact sales',
    price_explanation: 'pricing & features',
    keyFeature: {
      value: '8,000',
      title: 'Company Credits / Month',
    },
    pricing_groups: [
      'Unlimited company verifications',
      'Bulk Data Delivery',
      'Reseller License Included',
      'Exclusive Discount Rates',
      'Custom data sourcing',
    ],
  },
  {
    type: 'payg_pipeline_starter',
    name: 'Starter',
    description: 'For teams starting outbound',
    button_label: 'Get Started',
    price_explanation: '/month',
    price_explanation_year: '/year',
    pricing_groups: ['250 Emails per Month', '100 phone numbers per month', 'Browser extension', 'List enrichment'],
  },
  {
    type: 'payg_pipeline_professional',
    name: 'Professional',
    best_value: true,
    description: 'For growing sales teams',
    button_label: 'Get Started',
    price_explanation: '/month',
    price_explanation_year: '/year',
    pricing_groups: [
      '700 Emails per Month',
      '250 phone numbers per month',
      'Sales automation',
      'Salesforce, HubSpot, MS Dynamics',
    ],
  },
  {
    type: 'payg_pipeline_business',
    name: 'Business',
    description: 'For high-velocity prospecting',
    button_label: 'Get Started',
    price_explanation: '/month',
    price_explanation_year: '/year',
    pricing_groups: ['1,500 Emails per Month', '600 phone numbers per month', 'API access', 'Global group structure'],
  },
  {
    type: 'payg2_starter',
    name: 'Starter',
    description: 'For startups validating vendors',
    button_label: 'Get Started',
    price_explanation: '/month',
    price_explanation_year: '/year',
    keyFeature: {
      value: '100',
      title: 'Verifications per Month',
    },
    pricing_groups: ['Basic company check', 'Director data', 'Full audit trail'],
  },
  {
    type: 'payg2_professional',
    name: 'Professional',
    best_value: true,
    description: 'For scaling compliance ops',
    button_label: 'Get Started',
    price_explanation: '/month',
    price_explanation_year: '/year',
    keyFeature: {
      value: '400',
      title: 'Verifications per Month',
    },
    pricing_groups: ['UBO identification', 'Corporate structure', 'Financial data'],
  },
  {
    type: 'payg2_business',
    name: 'Business',
    description: 'For enterprise-grade verification',
    button_label: 'Get Started',
    price_explanation: '/month',
    price_explanation_year: '/year',
    keyFeature: {
      value: '900',
      title: 'Verifications per Month',
    },
    pricing_groups: ['API access', '500 API calls/minute', 'Change monitoring'],
  },
];
